namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmKrokTrasyPuvodni extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmKrokTrasyReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmKrokTrasyPuvodniObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmKrokTrasyPuvodniObj());
            this.detailObj.createBase({
                contentName: "detailAdmKrokTrasyPuvodni",
                contentCaption: "jres:33000800",  //RC 33000796 : Trasa dokumentů
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmKrokTrasyPuvodni", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmKrokTrasyPuvodniObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmKrokTrasyReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return `${this.data.ixs_tra}#${this.data.por_cislo}#`
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmKrokTrasySaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            if (this.options.newRecord == false)
                data.por_cislo = this.data.por_cislo;
            (this.cnt.isl.AdmKrokTrasy.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    });
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmKrokTrasyPuvodni", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmKrokTrasy.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.data.nazev}`;
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.form.form.layoutDescriptor = "L2M2S1";
            this.MakeSection("")
            this.MakeSelectField("ixs_tra", Gordic.Prefabs.Select.wflstra(), { model: "model.ixs_tra = value.ixs_tra" })
            this.MakeField("nazev")
            this.MakeField("poznamka")
            this.MakeSelectField("priz_pov_porad", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_pov_porad=value.priz_an" })
            this.MakeField("poradi", {
                validators: [new Gordic.Validators.Range({ stopping: true, min: 0 })]
            })
            this.MakeSelectField("ixs_su", Gordic.Prefabs.Select.ginspod(), {
                model: "model.ixs_su=value.ixs_su",
                serverFilters: {
                    aktivita: [100, 300, 500, 600, 900]
                }
            })
            this.MakeSelectField("ixs_fun", Gordic.Prefabs.Select.ginsfun(), {
                model: "model.ixs_fun=value.ixs_fun",
                serverFilters: {
                    ixs_su: new Gordic.Forms.Dependency("ixs_su", "ixs_su", true, false),
                    aktivita: [100, 300, 500, 600, 900]
                }
            })
            this.MakeSection("")
            this.MakeSelectField("priz_pov", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_pov=value.priz_an" })
            this.MakeSelectField("priz_edit", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_edit=value.priz_an" })
            this.MakeSelectField("typ_krok", Gordic.Prefabs.Select.admWflctkr(), { model: "model.typ_krok=value.typ_krok" })
            this.MakeField("dnu_termin", {
                validators: [new Gordic.Validators.Range({ stopping: true, min: 0 })]
            })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }
    }
}